export default __webpack_public_path__ + "static/media/signin_popup_image.a4159b87.jpg";